<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<v-btn
					fab
					class="mb-3"
					color="primary"
					small
					@click="newTongue = true"
				>
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<TCMTongueForm v-if="newTongue" @create-test="createTongue" @hide="newTongue = false" />
				<p v-if="tongues.length == 0" class="font-weight-thin ml-2">Nenhum template de língua criado.</p>
				<v-list v-else flat>
					<TestItem
						v-for="test in tongues"
						:test="test"
						type="tcm"
						:key="test.id"
						@delete-test="deleteTongue"
						@edit-test="editTongue"
					/>
				</v-list>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import TestItem from "@/components/appointment/tests/TestItem.vue";
import TCMTongueForm from "@/components/appointment/tests/tcm/TCMTongueForm.vue";
import axios from "axios";

export default {
  name: "Tongue",
  components: {
		NavBar,
		TestItem,
		TCMTongueForm
  },
  data: () => ({
		tongues: [],
		newTongue: false
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Tongue"),
					disabled: true,
					link: true
				}
			];
		}
	},
	methods: {
		createTongue(form) {
			console.log("ADD TONGUE");
			axios
				.post(
					"/admin/tongues/new",
					form
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "created") {
						this.tongues.push(response.data.tongue);
					}
				})
				.catch(error => console.log(error));
		},
		editTongue(tongue, form) {
			axios
				.post(
					"/admin/tongues/" +
					tongue.id +
					"/edit",
					form
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "edited") {
						this.tongues.splice(this.tongues.indexOf(tongue), 1);
						this.tongues.push(response.data.tongue);
					}
				})
				.catch(error => console.log(error));
		},
		deleteTongue(tongue) {
			axios
				.post(
					"/admin/tongues/" +
					tongue.id +
					"/delete"
				)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
						this.tongues.splice(this.tongues.indexOf(tongue), 1);
					}
				})
				.catch(error => console.log(error));
		}
	},
	created() {
		axios
			.get("/admin/tongues")
			.then(response => {
				console.log(response.data);
				this.tongues = response.data.tongues;
			})
			.catch(error => console.log(error));
	}
}
</script>